export default __webpack_public_path__ + "static/media/OMSC_03.c0f84fdf.gif";